import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 12l6 0","key":"svg-1"}]]

const IconCircleMinus = createReactComponent('outline', 'circle-minus', 'CircleMinus', __iconNode);

export default IconCircleMinus;